import Validator from "~/config/validation/validators/Validator";
import {isString} from "~/util/misc";
import ValidationError from "~/config/validation/ValidationError";
import {betterTypeOf} from "~/config/validation/validators/util";

export default class StringValidator extends Validator {
    /**
     * @param {any} value
     * @param {string|undefined} path
     * @return {string}
     */
    validate(value, path = undefined) {
        if (value === undefined && this.defaultValue !== undefined) {
            return this.validate(this.defaultValue, path);
        } else if (isString(value)) {
            return value;
        } else {
            throw new ValidationError(path, `Expected a string, but got ${betterTypeOf(value)}`);
        }
    }
}
